export const initialValues = {
  id: "",
  questionnaire_type:"",
  tax_return_type_id: "",
  tax_return_type_value: "",
  external_due_date: "",
  questionnaire_sending_date:"",
  color_code: "#000000",
};
